import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=d2c55788&scoped=true&"
import script from "./problems.vue?vue&type=script&lang=js&"
export * from "./problems.vue?vue&type=script&lang=js&"
import style0 from "./problems.vue?vue&type=style&index=0&id=d2c55788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c55788",
  null
  
)

export default component.exports